module.exports = __webpack_public_path__ + "static/img/1604_phase_function_Paper_Points.a1e4855.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1604_phase_function_Paper_Points.png
// module id = UkaW
// module chunks = 0